import { INITIAL_MAIL_COUNT, formatMailCount } from './initialMailCount'

/**
 * Get the exact mail count as a formatted string (e.g., "1,590,590")
 * Use this for live counters where you want the exact number
 */
export function getMailCountString(): string {
  return formatMailCount(INITIAL_MAIL_COUNT)
}

/**
 * Get a rounded, marketing-friendly mail count (e.g., "1.5 million")
 * Use this for static marketing copy where readability is more important than precision
 */
export function getMailCountRounded(): string {
  const count = INITIAL_MAIL_COUNT

  if (count >= 2000000) {
    // 2 million or more: "2 million", "2.5 million", etc.
    const millions = Math.floor(count / 500000) * 0.5
    return millions % 1 === 0 ? `${millions} million` : `${millions} million`
  } else if (count >= 1000000) {
    // 1-2 million: "1 million", "1.5 million"
    const millions = Math.floor(count / 500000) * 0.5
    return millions === 1 ? '1 million' : `${millions} million`
  } else if (count >= 100000) {
    // 100k-999k: Round to nearest 100k
    const hundredK = Math.round(count / 100000) * 100
    return `${hundredK}k`
  } else {
    // Under 100k: Round to nearest 1k
    const k = Math.round(count / 1000)
    return `${k}k`
  }
}

/**
 * Get the mail count description for use in feature cards
 * Uses rounded numbers for better readability in marketing copy
 */
export function getMailCountDescription(): string {
  return `Never lose a document again — over ${getMailCountRounded()} pieces of mail processed.`
}
